export default __webpack_public_path__ + "static/media/aave.085be81e.png";